import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import routes from './routes';
import axios from 'axios'
import {SYS} from '@/config'

Vue.use(VueRouter);

Vue.prototype.navigateTo = function(link) {
	if (this.$route.fullPath.includes('/window/')) {
		this.$router.push(`/window${this.$router.resolve(link).href}`);
	} else {
		this.$router.push(link);
	}
};
Vue.prototype.navigateBack = function(n = -1) {
	this.$router.go(n);
};
Vue.prototype.redirectTo = function(link) {
	this.$router.replace(link);
};
Vue.prototype.windowTo = function(link) {
	window.open(`/window${this.$router.resolve(link).href}`, '_blank', `width=1400,height=900,top=${(window.innerHeight-900)/2},left=${(window.innerWidth-1400)/2}`);
};

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes
});

const app = new Vue();
router.beforeEach(async function(to, from, next) {
	if (await new Promise(resolve => {
		axios.get(`//${window.location.host}/version.json?t=${new Date().getTime()}`).then(res => {
			if (res.status === 200) {
				if (window.sysVersion && window.sysVersion != res.data.version) {
					resolve(true);
				} else {
					window.sysVersion = res.data.version;
				}
			}
			resolve(false);
		}).catch(e => {
			console.error(e);
			resolve(false);
		});
	})) {
		window.location.href = router.resolve(to).href;
	}

	let redirect;
	if (!to.meta.loginFree) {
		if (!store.state.session) {
			redirect = `/login?redirect=${to.fullPath}`;
		} else if (to.name && !to.meta.authFree && !app.auth(to.name)) {
			redirect = '/';
		}
	}

	next(redirect);
});

export default router